import axiosConfig from "../axiosConfig";
import store from "../storeConfig";
import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";

const baseURL = getEnvVars().apiUrl;

export default function loadCharities() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });

    try {
      axi
        .get("/charities/list")
        .then((result) => {
          store.dispatch({
            type: "LOAD_CHARITIES",
            charities: result.data.charities,
          });
          // console.log(result)
        });
    } catch (error) {
      // console.log(error);
    }
  });
}

export function setCharity(charity_id) {
  var axi = axios.create({
    baseURL: baseURL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Authorization": store.getState().user.user.signInUserSession.idToken.jwtToken
    }
  }); 
}

export function updateCharity(charity_id) {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
    var data = {
                  "charityId": charity_id
    }
    axi.post('charities/update', data);
  });
}
